export default __webpack_public_path__ + "static/media/second-visual.6c3add61.png";